enum TipoRedirecionamento {
    LOGIN = 'L',
    CADASTRO = 'C',
    IGNORAR = 'I',
}

export default TipoRedirecionamento;
